// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-label{font-family:\"Proxima Nova Heavy\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\" !important;font-size:12px;color:#506784;letter-spacing:1px}.choices.is-disabled input.choices__input{background:rgba(0,0,0,0);display:none}", ""]);
// Exports
module.exports = exports;
